import { PlusIcon, ProductsIcon } from "@xola/icons";
import { Alert, Button } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { GiftOffer } from "types";
import { NoResults } from "../Common/NoResults";
import { Loader } from "../Loader";
import { GiftOfferTile } from "./GiftOfferTile";

interface GiftOfferListProps {
    giftOffers: GiftOffer[];
    isLoading: boolean;
    isFiltered: boolean;
}

export const GiftOfferList = ({ giftOffers = [], isLoading, isFiltered }: GiftOfferListProps) => {
    const filteredGiftOffers = giftOffers.filter((giftOffer: GiftOffer) => {
        return !giftOffer.baseGiftProduct && !giftOffer.experience;
    });

    if (filteredGiftOffers.length === 0) {
        return (
            <div className="py-15 px-10">
                <NoGiftsAlert />
            </div>
        );
    }

    if (filteredGiftOffers.length === 0 && isFiltered) {
        return <NoResults>No results found</NoResults>;
    }

    return (
        <div>
            {isLoading ? (
                <Loader size="tiny" className="p-2" text="Loading Gifts" />
            ) : (
                <div className="py-15 px-10">
                    {filteredGiftOffers.length > 0 || isFiltered ? (
                        <div className="grid grid-cols-2 gap-y-10 gap-x-12">
                            {filteredGiftOffers.map((giftOffer: GiftOffer) => (
                                <GiftOfferTile key={giftOffer.id} giftOffer={giftOffer} />
                            ))}
                        </div>
                    ) : null}
                </div>
            )}
        </div>
    );
};

export const NoGiftsAlert = () => {
    const history = useHistory();

    const handleCreateProductClick = () => {
        history.push("/products/giftOffers/create");
    };

    return (
        <div className="max-w-xl">
            <Alert color="primary">
                <div className="flex p-2">
                    <ProductsIcon size="large" />

                    <div className="ml-2" data-testid="gift-offer-list-no-gifts-alert">
                        <div className="mb-3 flex space-x-2">
                            <span className="text-md font-bold">No Gifts Found</span>
                        </div>

                        <span className="text-base">
                            You do not have any gift offers yet. Please create your first gift offer to get started.
                        </span>

                        <div className="mt-2 flex justify-end">
                            <Button size="small" color="primary" icon={<PlusIcon />} onClick={handleCreateProductClick}>
                                Create Gift
                            </Button>
                        </div>
                    </div>
                </div>
            </Alert>
        </div>
    );
};
